import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Link } from "./links.js";
import { name } from "./title.js";
export function Footer({ pkgVersion }) {
    return (_jsx("div", { className: `flex flex-col mt-12 text-gray-500 `, "data-testid": "footer", children: _jsxs("div", { className: `md:pl-16 md:ml-2 lg:pl-32 lg:text-center`, children: ["valotas.com ", _jsxs("strong", { children: ["v", pkgVersion || ""] }), " \u00A9 ", name(), " - CSS inspired by", ` `, _jsx(Link, { href: "https://adamwathan.me/", target: "_blank", children: "Adam Wathan's" }), ` `, "blog"] }) }));
}
